import * as React from 'react';
import { Plugin, Getter } from '@devexpress/dx-react-core';
import { IntegratedSelection, Row } from '@devexpress/dx-react-grid';

const IntegratedSelectionWrapper = () => {
  let allRows: Row[];
  return (
    <Plugin>
      <Getter
        name="rows"
        computed={({ rows }) => {
          allRows = rows;
          return rows.filter((row: Row) => row.disabledIndex);
        }}
      />
      <IntegratedSelection />
      <Getter name="rows" computed={() => allRows} />
    </Plugin>
  );
};

export { IntegratedSelectionWrapper };
